import { BASE_URL_API } from "../../../constants";
import fetcher from "../../../utils/fetcher";

export const _api_get_employees_to_compensate = async () => {
    return fetcher(`${BASE_URL_API}/overtime/users/list`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_type_leave_depend_employee = async ({ id_user }) => {
    return fetcher(`${BASE_URL_API}/overtime/user/${id_user}/leave_types`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_hours_employee = async ({ id_user }) => {
    return fetcher(`${BASE_URL_API}/overtime/user/${id_user}/details`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_post_compensate = async (data) => {
    return fetcher(
        `${BASE_URL_API}/overtime/user/${data.id_user}/leave_type/${data.solde_to_adjust}/compensate`,
        {
            method: "POST",
            credentials: "include",
            body: JSON.stringify({
                value_to_compensate: data.days,
                user_comment: data.reason,
            }),
        }
    );
};
